

export class StorageDaysOutputWithStatus implements IStorageDaysOutputWithStatus {
    /** The auto-generated id of the storage days master */
    storage_days_id!: number;
    /** The storage days name with 255 character limit */
    storage_days_name!: string;
    /** Manage status of storage days. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IStorageDaysOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storage_days_id = _data["storage_days_id"];
            this.storage_days_name = _data["storage_days_name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): StorageDaysOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StorageDaysOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storage_days_id"] = this.storage_days_id;
        data["storage_days_name"] = this.storage_days_name;
        data["status"] = this.status;
        return data; 
    }
}

export interface IStorageDaysOutputWithStatus {
    /** The auto-generated id of the storage days master */
    storage_days_id: number;
    /** The storage days name with 255 character limit */
    storage_days_name: string;
    /** Manage status of storage days. 0 For De-active, 1 For Active */
    status: number;
}

